export default __webpack_public_path__ + "static/media/omron.171ce7fe.png";